export function changeDraggableOrder<T>(destinationIndex: number, entityIndex: number, array: T[]) {
  const newArray = array.slice();
  const [item] = newArray.splice(entityIndex, 1);
  newArray.splice(destinationIndex, 0, item);

  return newArray;
}
